import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CurrencyRatesApiService } from './currency-rates-api.service';
import { CachedRequestsService } from '@gelato-api-ui/core/api/services/cached-requests.service';

@Injectable({
  providedIn: 'root',
})
export class CurrencyRateService {
  private readonly serviceName = 'CurrencyRateService';
  hasActiveRequests$ = this.cachedRequestsService.hasActiveRequests(this.serviceName);

  constructor(
    private readonly currencyRatesApiService: CurrencyRatesApiService,
    private readonly cachedRequestsService: CachedRequestsService,
  ) {}

  get(sourceCurrencyIsoCode: string, destinationCurrencyIsoCode: string): Observable<number> {
    if (!sourceCurrencyIsoCode || !destinationCurrencyIsoCode) {
      return of(null);
    }

    if (sourceCurrencyIsoCode === destinationCurrencyIsoCode) {
      return of(1);
    }

    const requestData = { sourceCurrencyIsoCode, destinationCurrencyIsoCode };

    return this.cachedRequestsService.get(this.serviceName, requestData, () =>
      this.currencyRatesApiService.get(sourceCurrencyIsoCode, destinationCurrencyIsoCode),
    );
  }
}
